module.exports = __webpack_public_path__ + "img/wallet.bbfd0ebd.svg";